<template>
  <div>
    <div id="tree" ></div>
  </div>
</template>

<!--<script src="jquery.fancytree/dist/skin-bootstrap/ui.fancytree.min.css"></script>-->
<script>

//import $ from "jquery";

import "jquery.fancytree/dist/skin-lion/ui.fancytree.css";

import {createTree, fancytree} from 'jquery.fancytree';
import 'jquery.fancytree/dist/modules/jquery.fancytree.filter';
import Vuex from "vuex";

import { filters } from "../store/filterModule.js";

var jsonTreeContent = 
    {
        "title": "bazbaz", "children":
        [
            {"title": "node 1"},
            {"title": "node 2", "folder": true, children: 
                [
                    {"title": "TEST 1"},
                    {"title": "TEST 2"}
                ] 
            }
        ]
    }

export default {
  props: ["keywordOntologies", "facetElements", "mutationName"],
  data() {
    return {
      tree: null
    };
  },
  components:{},
  computed: {
    ...Vuex.mapGetters([
      "getFacetClassification", "getFilters"
    ])
  },
  watch: {
    getFacetClassification() {
      this.updateTree();
    }
  },
  methods: {
    ...Vuex.mapActions(["searchObservations"]),
    updateTree() {
        console.log(this.facetElements);

        var selectedNodes = this.tree.getSelectedNodes();

        this.tree.clear();
        var rootNode = this.tree.getRootNode();
        var tree = {}

        console.log("FILTERS:");
        console.log(filters);

        $.each( filters.state.filters.keywordOntologies, function( index, ontology ){
          console.log("ProcessingOntology against " + ontology);
          tree[ontology] = {title: ontology, folder: true, children: [] };
        });

        $.each( this.facetElements, function( index, keyword ){
          console.log("Processing Keyword : " + keyword.name );
          $.each( tree, function( key, value ){
            console.log("Checking for match against " + key)
            if(keyword.name.startsWith(key)) {
              var sel = false;
              $.each( selectedNodes, function( index, node ){
                console.log(node);
                if (node.data.filterValue == keyword.name) {
                  sel = true;
                }
              });

              if (sel) {
                tree[key].children.push({title: keyword.displayName, folder: false, selected: true, filterValue: keyword.name})
              } else {
                tree[key].children.push({title: keyword.displayName, folder: false, filterValue: keyword.name})
              }
              
            }
          });
        });
        
        $.each( tree, function( key, value ){
          if (value != null) {
            rootNode.addChildren([value]);
          }
        });



        this.tree.expandAll();

        console.log(tree);
    },

    treeSelectEvent(event, data) {
      console.log(event);
      console.log(data);
      //if(data.node.selected) {
      //  filters.state.filters.keywords.push(node.data.filterValue);
      //}
      
      //else {
       // $.each(this.tree.getSelectedNodes(), function (event, node) {
       
       //filters.state.filters.keywords.push(node.data.filterValue);
       // });
      //}
      
      filters.state.filters.keywords = []
      $.each(this.tree.getSelectedNodes(), function (event, node) {
        filters.state.filters.keywords.push(node.data.filterValue);
      });
      console.log("Tree node select. New filters: ");
      console.log(this.getFilters);
      
      this.searchObservations(this.getFilters);
    },

    initTree() {
      this.tree = createTree('#tree', {
        //source: jsonTreeContent,
        checkbox: true,
        selectMode: 3,
        extensions: ["filter"],
        autoScroll: false,
        quicksearch: true,
        source: [],
        filter: {
          autoApply: true,   // Re-apply last filter if lazy data is loaded
          autoExpand: true,  // Expand all branches that contain matches while filtered
          counter: true,     // Show a badge with number of matching child nodes near parent icons
          fuzzy: false,      // Match single characters in order, e.g. "fb" will match "FooBar"
          hideExpandedCounter: true,  // Hide counter badge if parent is expanded
          hideExpanders: false,       // Hide expanders if all child nodes are hidden by filter
          highlight: true,   // Highlight matches by wrapping inside <mark> tags
          leavesOnly: false, // Match end nodes only
          nodata: true,      // Display a "no data" status node if result is empty
          mode: "hide"       // Grayout unmatched nodes (pass "hide" to remove unmatched node instead "dimm" to grey out non matches)
        },
        select: this.treeSelectEvent
      });
    },
  },
  mounted() {
    this.initTree();
  }
};

</script>

<style>

  .custom label {
    float: left;
  }

  ul.fancytree-container {
    border: none;
    font-size: 11px;
}

</style>